import React from "react";
import FetchTVShows from "../../components/FetchTVShows/FetchTVShows";

const TopRatedTVShows = () => {
  return <FetchTVShows slug="top_rated" pageTitle="Top Rated" />;
};

export default TopRatedTVShows;
